import { c as _c } from "react/compiler-runtime";
import { ReactElement } from 'react';
import { useExternalFilterBridge } from '../../../../hooks/useExternalFilterBridge';
import { FormToDataGridConnectorProps } from '../../../../types/FormToDataGridConnectorProps';
export type CustomFiltersPanelProps = {
  filterComponent: (props: FormToDataGridConnectorProps) => ReactElement;
};

/**
 * Renders the `filterComponent` render-prop function inside the sidebar filter panel.
 *
 * Delegates store↔filter bridging to `useExternalFilterBridge`.
 *
 * @see ExternalFiltersPortal — equivalent component for portal-based external rendering
 */
export function CustomFiltersPanel(props) {
  const $ = _c(4);
  const {
    values,
    onChange
  } = useExternalFilterBridge();
  const FilterComponent = props.filterComponent;
  let t0;
  if ($[0] !== FilterComponent || $[1] !== onChange || $[2] !== values) {
    t0 = <div className="flex flex-col gap-3 p-4 overflow-y-auto h-full"><FilterComponent values={values} onChange={onChange} /></div>;
    $[0] = FilterComponent;
    $[1] = onChange;
    $[2] = values;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}